import { DEFAULT_DATE_FORMATE } from '../../../constents';
import { useEffect, useState, useCallback } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import { format, subDays } from 'date-fns';
import { ucFirst } from '../../../Utilities/Utilities';
import IntaleList from './IntaleList';
import AddIntakeFormPopup from './AddIntakeFormPopup';
import Pagination from '../../../Utilities/Pagination';
import Button from '../../Button';
import DatePickerCalander from '../../../Utilities/DatePickerCalander';
import { useSelector } from 'react-redux';

function Intake() {
  const [allData, setAllData] = useState([]);
  const [reload, setReload] = useState(false);
  const [intakeFormPopup, setIntakeFormPopup] = useState(false);
  const { user } = useSelector((store) => store.auth);

  const [intakeData, setIntakeData] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    filterValue: '90D',
    selectedState: '',
    stDatePickerIsOpen: false,
    ndTimePickerIsOpen: false,
    isDateRange: false,
    intakeSortBy: 'desc',
    intakeSortColName: 'intakeSent',
    searchTermName: '',
    searchTermChart: '',
    searchField: '',
    intakeStatus: '2',
    intakeResource: 'ALL',
    intakeAction: '1',
  });

  const [limit, setSetLimit] = useState(200);
  const [offset, setSetOfset] = useState(0);

  const handleFilterChange = useCallback((data) => {
    setIntakeData(data);
    setSetOfset(0);
  }, []);

  const handlePageChange = useCallback((data) => {
    setSetLimit(data[1]);
    setSetOfset(data[0]);
  }, []);

  useEffect(() => {
    if (
      intakeData.isDateRange &&
      (!intakeData.startDate || !intakeData.endDate)
    ) {
      return;
    }

    (async () => {
      try {
        const response = await post('api/patient/intake/loadIntakeGridView', {
          ...intakeData,
          loginUserId: user?.id,
          limit: limit,
          offset: offset,
          startDate: intakeData.startDate
            ? format(intakeData.startDate, 'yyyy-MM-dd')
            : '',
          endDate: intakeData.endDate
            ? format(intakeData.endDate, 'yyyy-MM-dd')
            : '',
        });
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    })();
  }, [intakeData, reload, user?.id, limit, offset]);
  return (
    <div id="preauthMaingrid" className="preauth-Maingrid-Pat">
      <div className="intake-mid-bdy-hdr">
        <span
          className="widget-hdr-title bold clear-top"
          style={{ color: 'white' }}
        >
          Patients Intake:
        </span>
      </div>
      <div className="bnc-mn-hdr">
        <div className="bill-dt-main-con">
          <div className="bill-days-blk">
            <span className="intake-head-inpt-main">
              <span className="intake-head-hedding">Duration:</span>
              <span className="intake-head-inpt-sec">
                <input
                  type="radio"
                  name="radio2"
                  onChange={() =>
                    handleFilterChange((prev) => ({
                      ...prev,
                      filterValue: 'ALL',
                      isDateRange: false,
                      startDate: null,
                      endDate: null,
                    }))
                  }
                  checked={intakeData?.filterValue === 'ALL' ? true : false}
                />
                <span className="">All</span>
              </span>

              <span className="intake-head-inpt-sec">
                <input
                  type="radio"
                  name="radio2"
                  onChange={() =>
                    handleFilterChange((prev) => ({
                      ...prev,
                      filterValue: '90D',
                      isDateRange: false,
                      startDate: subDays(new Date(), 90),
                      endDate: new Date(),
                    }))
                  }
                  checked={intakeData?.filterValue === '90D' ? true : false}
                />
                <span className="">90 days</span>
              </span>

              <span className="intake-head-inpt-sec">
                <input
                  type="radio"
                  name="radio2"
                  onChange={() =>
                    handleFilterChange((prev) => ({
                      ...prev,
                      filterValue: '60D',
                      isDateRange: false,
                      startDate: subDays(new Date(), 60),
                      endDate: new Date(),
                    }))
                  }
                  checked={intakeData?.filterValue === '60D' ? true : false}
                />
                <span className="">60 days</span>
              </span>

              <span className="intake-head-inpt-sec">
                <input
                  type="radio"
                  name="radio2"
                  onChange={() =>
                    handleFilterChange((prev) => ({
                      ...prev,
                      filterValue: '30D',
                      isDateRange: false,
                      startDate: subDays(new Date(), 30),
                      endDate: new Date(),
                    }))
                  }
                  checked={intakeData?.filterValue === '30D' ? true : false}
                />
                <span className="">30 days</span>
              </span>

              <div className="intake-serch-calander-sec">
                <span className="intake-head-inpt-sec">
                  <input
                    type="radio"
                    name="radio2"
                    onClick={() =>
                      handleFilterChange((prev) => ({
                        ...prev,
                        filterValue: 'D',
                        isDateRange: true,
                        startDate: null,
                        endDate: null,
                      }))
                    }
                  />
                </span>
                <span className="intake-serch-calander">
                  <DatePickerCalander
                    selectedDate={intakeData.startDate}
                    setSelectedDate={(date) =>
                      handleFilterChange((prev) => ({ ...prev, startDate: date }))
                    }
                    className="add-task-date-picker"
                    style={{
                      width: '75px',
                    }}
                    dateFormat={DEFAULT_DATE_FORMATE}
                    maxDate={intakeData?.endDate}
                    editFlag={!intakeData.isDateRange}
                  />
                </span>
                <span className="date-sep-blu-hdr">-</span>
                <span className="intake-serch-calander">
                  <DatePickerCalander
                    selectedDate={intakeData.endDate}
                    setSelectedDate={(date) =>
                      handleFilterChange((prev) => ({ ...prev, endDate: date }))
                    }
                    className="add-task-date-picker"
                    style={{
                      width: '75px',
                    }}
                    dateFormat={DEFAULT_DATE_FORMATE}
                    minDate={intakeData?.startDate}
                    editFlag={!intakeData.isDateRange}
                  />
                </span>
              </div>
            </span>
          </div>
          <Button variant="primary" onClick={() => setIntakeFormPopup(true)}>
            Send Intake
          </Button>
        </div>
      </div>
      <div className="intake-paging">
        <Pagination
          totalRecord={Number(allData && allData?.rowCount) || 0}
          onPageChange={handlePageChange}
          offset={offset}
          rowPerPage={limit}
        />
      </div>
      <div className="preauth-Maingrid-Patbdy grid-sec clear-top10 pt-intake-grid">
        <div className="intake-Maingrid-Pat-hdr grid-sec">
          <div className="preauth-Maingrid-Pat-sbhdr flex-sec">
            <span className="pacolm5">Intake Sent</span>
            <span className="pacolm5">Provider</span>
            <span className="pacolm5">Sent By</span>
            <span className="pacolm5">Chart#</span>
            <span className="pacolm4">Name</span>
            <span className="pacolm5">Appointment</span>
            <span className="pacolm5">Status</span>
            <span className="pacolm4">Action</span>
          </div>
          <div className="preauth-Maingrid-Pat-sbhdr flex-sec">
            <span className="pacolm5"></span>
            <span className="pacolm5">
              <select
                className="inpt-width-nw"
                id="pairsubscriber"
                name="pairsubscriber"
                value={intakeData.intakeResource}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    intakeResource: e.target.value,
                  }))
                }
              >
                <option value="ALL">ALL</option>
                {allData?.allResource &&
                  allData?.allResource.map((item, i) => (
                    <option key={i} value={item?.id}>
                      {`${ucFirst(item?.first_name)} ${ucFirst(
                        item?.last_name
                      )}${item?.degree ? ', ' + item?.degree : ''}`}
                    </option>
                  ))}
              </select>
            </span>
            <span className="pacolm5"></span>
            <span className="pacolm5">
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="chartnumber"
                name="chartnumber"
                value={intakeData.searchTermChart}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    searchTermChart: e.target.value,
                    searchField: 'intakePatChartSearch',
                    searchTermName: '',
                  }))
                }
              />
            </span>
            <span className="pacolm4">
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="chartnumber"
                name="chartnumber"
                value={intakeData.searchTermName}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    searchTermName: e.target.value,
                    searchField: 'intakePatNameSearch',
                    searchTermChart: '',
                  }))
                }
              />
            </span>
            <span className="pacolm5"></span>
            <span className="pacolm5">
              <select
                className="inpt-width-nw"
                id="pairsubscriber"
                name="pairsubscriber"
                value={intakeData.intakeStatus}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    intakeStatus: e.target.value,
                  }))
                }
              >
                <option value="ALL">ALL</option>
                <option value="0">Pending</option>
                <option value="2">Received</option>
                <option value="3">Complete</option>
              </select>
            </span>
            <span className="pacolm4">
              <select
                className="inpt-width-nw"
                id="pairsubscriber"
                name="pairsubscriber"
                value={intakeData.intakeAction}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    intakeAction: e.target.value,
                  }))
                }
              >
                <option value="0">Removed</option>
                <option value="1">Active</option>
              </select>
            </span>
          </div>
        </div>
        <div className="intake-Maingrid-Pat-sb-bdy qgrid-sec">
          {allData?.intakeData &&
            allData?.intakeData.map((item, i) => (
              <div
                key={i}
                className={
                  i % 2 === 0
                    ? 'preauth-Maingrid-Pat-bdy-rw flex-sec alt-rw'
                    : 'preauth-Maingrid-Pat-bdy-rw flex-sec'
                }
              >
                <IntaleList
                  item={item}
                  //handlePopupOpen={handlePopupOpen}
                  handleReload={() => setReload(!reload)}
                />
              </div>
            ))}
        </div>
      </div>
      {intakeFormPopup && (
        <AddIntakeFormPopup
          close={() => setIntakeFormPopup(false)}
          handleReload={() => setReload(!reload)}
        />
      )}
    </div>
  );
}

export default Intake;
